import Api, { handleError } from '@/services/Api';


// const API_URL = 'http://localhost:8000/api';
const API_URL = process.env.API_BASE;


export async function getAll() {
  const url = `${API_URL}/plan/`;
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function getPlanGenerate() {
  const url = `${API_URL}/plan_generate/`;
  const { status, data } = await Api.get(url)
    .catch(handleError);

  return { status, data };
}
